<template>
    <div class="page" v-if="isDataLoaded">
        <div v-html="detail.contents" class="b1"></div>
    </div>
</template>

<script>
import mix1 from '@/mixins/page'
import { uiShowLoading, uiHideLoading, uiAlert, uiConfirm } from '@/utils/ui'
import { delayAsync } from '@/utils/common'
import { Button, Tab, Tabs, Progress, Empty } from 'vant'
import MgPopup from '@/components/common/mg-popup'

export default {
    mixins: [mix1],
    components: {
        MgPopup,
        [Button.name]: Button,
        [Tab.name]: Tab,
        [Tabs.name]: Tabs,
        [Progress.name]: Progress,
        [Empty.name]: Empty,

    },
    data() {
        return {
            showPivot: false,
            searchForm: {
                id: 0,
            },
            detail: {}
        }
    },
    methods: {

        toUrl(url) {
            this.$router.push(url)
        },
        async loadData() {

            uiShowLoading()
            await delayAsync(500)

            const promise = this.apiGet('category.info', this.searchForm)

            let apiResult = null

            try {
                apiResult = await promise
            } catch (ex) {
                apiResult = null
            }

            uiHideLoading()

            if (this.hasException(apiResult)) {
                return
            }
            this.isDataLoaded = true
            this.detail = apiResult.obj
            this.asyncTile(apiResult.obj.title)
        },
    },
    mounted() {

    },
    created() {
        let query = this.$route.query
        this.searchForm.id = query.id
        this.loadData()
    }
}
</script>

<style lang="less">
.rd {
    .van-progress {
        width: 200px;
    }
}

.van-empty__image {
    width: 500px;
    height: 500px;
}
</style>
<style lang="less" scoped>
.page {
    .rt-img {
        display: block;
        max-width: 100%;
        margin: 0 auto;
    }

    .b1 {
        background: #fff;
        padding: 30px 20px;
        box-sizing: border-box;
        margin-top: 20px;
    }
}
</style>